import * as React from "react";
import ArchiveSidebar from "./ArchiveSidebar";
import { createBrowserHistory } from "history";
import {
  LoadArchive,
  GetArchiveList,
  CreateArchive,
  UpdateArchive,
  DeleteArchive
} from "../../../../actions/ArchiveActions";
import ArchiveStore from "../../../../stores/ArchiveStore";
import { Link } from "react-router-dom";
const customHistory = createBrowserHistory();
class ArchiveView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentArchive: {
        archvieId: 0,
        rootPath: "",
        isCurrent: true
      },
      archiveId: 0,
      archivePath: "",
      isCurrent: false,
      isDirty: false,
      errorOne: "",
      isSaving: false,
      deleteStatus: 0
    };
    this.updateArchive = this.updateArchive.bind(this);
    this.onStoreUpdate = this.onStoreUpdate.bind(this);
    this.isCurrentChange = this.isCurrentChange.bind(this);
    this.handleArchivePathChange = this.handleArchivePathChange.bind(this);
    this.handleSaveOneClick = this.handleSaveOneClick.bind(this);
    this.startDelete = this.startDelete.bind(this);
    this.deleteArchive = this.deleteArchive.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
  }
  componentDidMount() {
    ArchiveStore.addChangeListener(this.onStoreUpdate);
    this.updateArchive();
  }
  componentWillUnmount() {
    ArchiveStore.removeChangeListener(this.onStoreUpdate);
  }
  componentDidUpdate() {
    this.updateArchive();
  }
  updateArchive() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let archId = parseInt(pathParts[pathParts.length - 1], 10);
    if (archId !== 0 && (this.state.currentArchive === void 0 || this.state.currentArchive.archiveId !== archId)) {
      LoadArchive(archId);
    } else if (archId === 0 && this.state.currentArchive !== void 0 && this.state.currentArchive.archiveId !== 0) {
      let currentArch = {};
      currentArch.rootPath = "";
      currentArch.archiveId = 0;
      currentArch.isCurrent = true;
      this.setState({
        currentArchive: currentArch,
        isCurrent: true,
        archivePath: ""
      });
    }
  }
  isCurrentChange(e) {
    this.setState({ isCurrent: e.target.checked, isDirty: true });
  }
  onStoreUpdate() {
    let lastAction = ArchiveStore.lastChange();
    if (lastAction === "ArchiveLoadOne") {
      let arch = ArchiveStore.getCurrentArchive();
      this.setState({
        currentArchive: arch,
        archivePath: arch.rootPath,
        isCurrent: arch.isCurrent,
        isDirty: false,
        isSaving: false
      });
    }
    if (lastAction === "ArchiveUpdateOne") {
      let lastError = ArchiveStore.getLastError();
      if (lastError === "" || lastError === void 0) {
        let newDir = ArchiveStore.getCurrentArchive();
        if (newDir.uploadId !== this.state.currentArchive.archiveId) {
          customHistory.push(`/Admin/ArchiveView/${newDir.archiveId}`);
        }
        this.setState({
          errorOne: "",
          currentArchive: newDir,
          uploadPath: newDir.uploadPath,
          isCurrent: newDir.isCurrent,
          ftps: newDir.bPs,
          routingType: newDir.intakeRoutingType,
          selectedIs: newDir.intakeStrategyId,
          isSecOneSaving: false,
          isSecTwoDirty: false,
          isSecOneDirty: false,
          isSecTwoSaving: false
        });
        GetArchiveList();
      } else {
        this.setState({ isSecOneSaving: false, errorOne: lastError });
      }
    }
    if (lastAction === "ArchiveDelete") {
      let lastError = ArchiveStore.getLastError();
      if (lastError === "") {
        let link = document.getElementById("archiveHome");
        link.click();
      } else {
        this.setState({ isSecOneSaving: false, errorOne: lastError });
      }
    }
  }
  handleArchivePathChange(e) {
    this.setState({ archivePath: e.target.value, isDirty: true });
  }
  handleSaveOneClick(e) {
    this.setState({ isSecOneSaving: true });
    if (this.state.currentArchive.archiveId === 0) {
      CreateArchive(this.state.archivePath, this.state.isCurrent);
    } else {
      UpdateArchive(
        this.state.currentArchive.archiveId,
        this.state.archivePath,
        this.state.isCurrent
      );
    }
  }
  startDelete() {
    this.setState({ deleteStatus: 1 });
  }
  deleteArchive() {
    DeleteArchive(this.state.currentArchive.archiveId);
    this.setState({ deleteStatus: 0 });
  }
  cancelDelete() {
    this.setState({ deleteStatus: 0 });
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(ArchiveSidebar, null), /* @__PURE__ */ React.createElement(
      Link,
      {
        id: "archiveHome",
        className: "nav-link",
        to: `/Admin/Archive`,
        style: { display: "none" }
      }
    ), this.state.currentArchive !== void 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "flex-fill",
        style: { backgroundColor: "#efefef", overflow: "scroll" }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "20px",
            marginLeft: "30px",
            marginRight: "30px",
            maxHeight: "620px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("h4", null, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-archive" }), "  ", this.state.currentArchive.rootPath)),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "uploadPathTxt", className: "form-label" }, "Archive Path:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "uploadPathTxt",
            value: this.state.archivePath,
            onChange: this.handleArchivePathChange
          }
        )), /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "form-check form-switch",
            style: { marginTop: "10px" }
          },
          /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "form-check-input",
              type: "checkbox",
              id: "flexSwitchCheckChecked",
              onChange: this.isCurrentChange,
              checked: this.state.isCurrent
            }
          ),
          /* @__PURE__ */ React.createElement(
            "label",
            {
              className: "form-check-label",
              htmlFor: "flexSwitchCheckChecked"
            },
            this.state.isCurrent && /* @__PURE__ */ React.createElement("span", null, "Current"),
            !this.state.isCurrent && /* @__PURE__ */ React.createElement("span", null, "Not current")
          )
        ), /* @__PURE__ */ React.createElement("div", { className: "mb-3", style: { marginTop: "8px" } }, this.state.isDirty && !this.state.isSaving && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary",
            onClick: this.handleSaveOneClick
          },
          "Save"
        ), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-danger",
            style: { marginLeft: "6px" },
            onClick: this.startDelete
          },
          "Delete"
        )), !this.state.isDirty && !this.state.isSaving && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "btn btn-primary disabled" }, "Save"), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-danger",
            style: { marginLeft: "6px" },
            onClick: this.startDelete
          },
          "Delete"
        )), this.state.isSaving && /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-spinner", size: "2x", spin: true }), this.state.deleteStatus === 1 && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "alert alert-danger",
            style: { marginTop: "6px" },
            role: "alert"
          },
          /* @__PURE__ */ React.createElement("p", null, "Are you sure you want to delete this archive?"),
          /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-danger",
              onClick: this.deleteArchive
            },
            "Yes - Delete"
          ),
          /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-secondary",
              style: { marginLeft: "6px" },
              onClick: this.cancelDelete
            },
            "Cancel"
          )
        ), this.state.errorOne !== "" && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "alert alert-danger",
            style: { marginTop: "6px" },
            role: "alert"
          },
          this.state.errorOne
        )))
      )
    )));
  }
}
export default ArchiveView;
